import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.defaults({
    ease: "ease",
    duration: 1,
});

gsap.config({
    nullTargetWarn: false,
    autoSleep: 60,
    force3D: false,
});
